import NewsParagraph from "../components/NewsParagraph.tsx";
import ArticleContainer from "../components/ArticleContainer.tsx";

function Rubio() {
  return (
    <ArticleContainer>
      <NewsParagraph>
        Impostor uses AI to impersonate Rubio and contact foreign and US
        officials
      </NewsParagraph>
      <NewsParagraph>July 8, 2025</NewsParagraph>
      <NewsParagraph>By MATTHEW LEE</NewsParagraph>
      <NewsParagraph>
        WASHINGTON (AP) — The State Department is warning U.S. diplomats of
        attempts to impersonate Secretary of State Marco Rubio and possibly
        other officials using technology driven by artificial intelligence,
        according to two senior officials and a cable sent last week to all
        embassies and consulates.
      </NewsParagraph>
      <NewsParagraph>
        The warning came after the department discovered that an impostor posing
        as Rubio had attempted to reach out to at least three foreign ministers,
        a U.S. senator and a governor, according to the July 3 cable, which was
        first reported by The Washington Post.
      </NewsParagraph>
      <NewsParagraph>
        The recipients of the scam messages, which were sent by text, Signal and
        voice mail, were not identified in the cable, a copy of which was shared
        with The Associated Press.
      </NewsParagraph>
      <NewsParagraph>
        “The State Department is aware of this incident and is currently
        monitoring and addressing the matter,” department spokeswoman Tammy
        Bruce told reporters. “The department takes seriously its responsibility
        to safeguard its information and continuously take steps to improve the
        department’s cybersecurity posture to prevent future incidents.”
      </NewsParagraph>
      <NewsParagraph>
        She declined to comment further due to “security reasons” and the
        ongoing investigation.
      </NewsParagraph>
      <NewsParagraph>
        It’s the latest instance of a high-level Trump administration figure
        targeted by an impersonator, with a similar incident revealed in May
        involving President Donald Trump’s chief of staff, Susie Wiles. The
        misuse of AI to deceive people is likely to grow as the technology
        improves and becomes more widely available, and the FBI warned this past
        spring about “malicious actors” impersonating senior U.S. government
        officials in a text and voice messaging campaign.
      </NewsParagraph>
      <NewsParagraph>
        The hoaxes involving Rubio had been unsuccessful and “not very
        sophisticated,” one of the officials said. Nonetheless, the second
        official said the department deemed it “prudent” to advise all employees
        and foreign governments, particularly as efforts by foreign actors to
        compromise information security increase.
      </NewsParagraph>
      <NewsParagraph>
        The officials were not authorized to discuss the matter publicly and
        spoke on condition of anonymity.
      </NewsParagraph>
      <NewsParagraph>
        “There is no direct cyber threat to the department from this campaign,
        but information shared with a third party could be exposed if targeted
        individuals are compromised,” the cable said.
      </NewsParagraph>
      <NewsParagraph>
        The FBI has warned in a public service announcement about a “malicious”
        campaign relying on text messages and AI-generated voice messages that
        purport to come from a senior U.S. official and that aim to dupe other
        government officials as well as the victim’s associates and contacts.
      </NewsParagraph>
      <NewsParagraph>
        This is not the first time that Rubio has been impersonated in a
        deepfake. This spring, someone created a bogus video of him saying he
        wanted to cut off Ukraine’s access to Elon Musk’s Starlink internet
        service. Ukraine’s government later rebutted the false claim.
      </NewsParagraph>
      <NewsParagraph>
        Several potential solutions have been put forward in recent years to the
        growing misuse of AI for deception, including criminal penalties and
        improved media literacy. Concerns about deepfakes have also led to a
        flood of new apps and AI systems designed to spot phonies that could
        easily fool a human.
      </NewsParagraph>
      <NewsParagraph>
        The tech companies working on these systems are now in competition
        against those who would use AI to deceive, according to Siwei Lyu, a
        professor and computer scientist at the University at Buffalo. He said
        he’s seen an increase in the number of deepfakes portraying celebrities,
        politicians and business leaders as the technology improves.
      </NewsParagraph>
      <NewsParagraph>
        Just a few years ago, fakes contained easy-to-spot flaws — inhuman
        voices or mistakes like extra fingers — but now the AI is so good, it’s
        much harder for a human to spot, giving deepfake makers an advantage.
      </NewsParagraph>
      <NewsParagraph>
        “The level of realism and quality is increasing,” Lyu said. “It’s an
        arms race, and right now the generators are getting the upper hand.”
      </NewsParagraph>
      <NewsParagraph>
        The Rubio hoax comes after text messages and phone calls went to elected
        officials, business executives and other prominent figures from someone
        who seemed to have gained access to the contacts in Wiles’ personal
        cellphone, The Wall Street Journal reported in May.
      </NewsParagraph>
      <NewsParagraph>
        Some of those who received calls heard a voice that sounded like Wiles,
        which may have been generated by AI, according to the newspaper. The
        messages and calls were not coming from Wiles’ number, the report said.
        The government was investigating.
      </NewsParagraph>
      <NewsParagraph>
        AP writers David Klepper and Eric Tucker contributed to this report.
      </NewsParagraph>
      <NewsParagraph>
        Hint: for the teaser, the NPCs tell you about the characteristics of
        other NPCs. One among those NPCs can be proved to be lying about those
        characteristics...
      </NewsParagraph>
    </ArticleContainer>
  );
}

export default Rubio;
